import { useCouriers } from 'common/Hooks/UseTranslatedCouriers'
import { getDate, getMeasure, getStatusClassName } from 'common/Utils/StringUtilities'
import Modal from 'components/Common/Modal/Modal'
import { Tracking } from 'pages/SupplierProduction/Tracking'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import DetailPartProduction from './DetailPartProduction'

export const PartProduction = ({ t, production, openedProductionIds, handleToggleProduction, rowIndex }) => {
	const [productionInTrackingModal, setProductionInTrackingModal] = useState(null)
	const [trackingModalIsOpen, setTrackingModalIsOpen] = useState(false)

	const { COURIER } = useCouriers(t)

	const isProductionExpanded = openedProductionIds.includes(production.id)
	const iconClassName = isProductionExpanded ? 'fs-2 cursor-pointer bx bx-chevron-up' : 'fs-2 cursor-pointer bx bx-chevron-down'
	const calculateTotalWeight = () => {
		let totalWeight = 0
		production.productionItemList.forEach(item => {
			const partWeight = item.part.weight
			const shippedQuantity = item.shippedQuantity
			totalWeight += partWeight * shippedQuantity
		})
		return totalWeight
	}

	const calculateTotalImport = () => {
		let totalImport = 0
		production.productionItemList.forEach(item => {
			const partImport = item.unitPurchasePrice
			const shippedQuantity = item.shippedQuantity
			totalImport += partImport * shippedQuantity
		})
		return Math.round(totalImport * 100) / 100
	}

	const totalWeight = calculateTotalWeight()
	const totalImport = calculateTotalImport()
	const addTwoHours = (date) => {
		date.setTime(date.getTime() + 2 * 60 * 60 * 1000)
		const day = String(date.getDate()).padStart(2, '0')
		const month = String(date.getMonth() + 1).padStart(2, '0')
		const year = date.getFullYear()
		const hours = String(date.getHours()).padStart(2, '0')
		const minutes = String(date.getMinutes()).padStart(2, '0')
		const seconds = String(date.getSeconds()).padStart(2, '0')

		return {
			date: `${day}/${month}/${year}`,
			hour: `${hours}:${minutes}:${seconds}`,
		}
	}

	const dateToFormat = production.orderDate
	const toFormat = new Date(dateToFormat)
	const orderDateFromProduction = addTwoHours(toFormat)

	return (
		<div className='d-flex flex-column'>
			<div className={`bg-white w-100 my-1 mx-2 p-4 rounded d-flex flex-row align-items-center`}>
				<span className='col-1'><i onClick={() => { handleToggleProduction(production.id) }} className={iconClassName} ></i></span>
				<span className='col-1'><Link to={`production/${production.displayId}`}>{production.displayId}</Link></span>
				<span className='col-2'><div className='d-flex flex-column'>
					<span>{orderDateFromProduction.date}</span>
					<span>{orderDateFromProduction.hour}</span>
				</div></span>
				<div className='col-2'><span className={`${getStatusClassName(`production_status_${production.statusId}`)}`}>{t(`production_status_${production.statusId}`, { ns: 'status' })}</span></div>
				<span className='col-2'><div className='d-flex flex-column'>
					<span>{getDate(production.shipmentDateReal)}</span>
				</div></span>
				<span className='col-1'>{getMeasure(totalWeight, 'g')}</span>
				<span className='col-2'><Tracking
					trackingId={production.shipmentTrackingNumber}
					courier={production.courier}
					estimatedArrivalDate={production.arrivalDateEstimated}
					status={production.statusId}
					isInPartProduction={true}
					overrideOnClick={() => {
						setProductionInTrackingModal(production)
						setTrackingModalIsOpen(true)
					}}
				/></span>
				<span className='col-1' style={{ marginLeft: '25px' }}>{totalImport} €</span>

			</div>
			<Modal
				isOpen={trackingModalIsOpen}
				closeModal={() => setTrackingModalIsOpen(false)}
				body={(
					<div className='m-3 mt-5 row gap-2 align-items-center'>
						{/* Transportista */}
						<div className='col'>
							<strong>{t('courier', { ns: 'naming' })}{': '}</strong>
						</div>
						<div className='col'>
							{COURIER[productionInTrackingModal?.courier]}
						</div>
						<div className="w-100" />
						{/* Seguimiento */}
						<div className='col'>
							<strong>{t('tracking', { ns: 'naming' })}{': '}</strong>
						</div>
						<div className='col'>
							<Tracking
								trackingId={productionInTrackingModal?.shipmentTrackingNumber}
								courier={productionInTrackingModal?.courier}
								estimatedArrivalDate={productionInTrackingModal?.arrivalDateEstimated}
								status={productionInTrackingModal?.statusId}
							/>
						</div>
						<div className="w-100" />
						{/* Fecha de envio */}
						<div className='col'>
							<strong>{t('shipmentDate', { ns: 'naming' })}{': '}</strong>
						</div>
						<div className='col'>
							{getDate(productionInTrackingModal?.shipmentDateReal)}
						</div>
						<div className="w-100" />
					</div>
				)}
				closeButtonColor="secondary"
			/>
			<div className='ms-4'>
				{isProductionExpanded && (
					production.productionItemList.map((item, index) => (
						<div key={index}>
							<DetailPartProduction item={item} index={index} />
						</div>
					))
				)}
			</div>
		</div>
	)
}

PartProduction.propTypes = {
	t: PropTypes.func,
	production: PropTypes.object,
	openedProductionIds: PropTypes.array,
	handleToggleOrder: PropTypes.func,


}

const mapStateToProps = (state) => ({
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PartProduction))
